export default function Star1({
  fill = '#fff',
  width = '4',
  height = '5',
  className,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 4 5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2 1.33105C2.26666 1.78361 2.61766 2.18142 3.03613 2.5C2.61789 2.81841 2.2666 3.21571 2 3.66797C1.73326 3.21549 1.38141 2.81849 0.962891 2.5C1.38163 2.18134 1.73321 1.78384 2 1.33105Z'
        fill={fill}
        stroke='white'
      />
    </svg>
  );
}
